module.exports = __webpack_public_path__ + "img/banner.3c50aaaa.jpg";